import { IcpInfo } from "../schema/icp";
import { sleep } from "./onboardingChatTiming";

export interface PollIcpOptions {
	fetchIcp: () => Promise<IcpInfo>;
	maxWaitMs: number;
	pollIntervalMs: number;
	/** Aborts between attempts once the chat has been left. */
	isCancelled: () => boolean;
	now?: () => number;
}

/**
 * Waits for the signup job's ICP guess. `NEEDS_HINT` means no guess is coming
 * for this company at all (we hold no description of it), so polling out the
 * deadline would be pure dead time in front of a question we have to ask
 * anyway — bail out immediately and let the caller open the thin branch.
 */
export const pollIcpUntilReady = async ({
	fetchIcp,
	maxWaitMs,
	pollIntervalMs,
	isCancelled,
	now = Date.now,
}: PollIcpOptions): Promise<IcpInfo | null> => {
	const deadline = now() + maxWaitMs;

	while (!isCancelled() && now() < deadline) {
		try {
			const icp = await fetchIcp();

			if (icp.status === "READY") {
				return icp;
			}

			if (icp.status === "NEEDS_HINT") {
				return null;
			}
		} catch (err) {
			console.error(err);
		}

		await sleep(pollIntervalMs);
	}

	return null;
};
